<template>
    <div>
        <div class="sidebar">
            <ul class="sidebar-list">
                <li v-has-role="['owner', 'manager']" :class="{ 'active': path === '/organization/settings/profile' }">
                    <router-link to="/organization/settings/profile">
                        <span class="icon icon-profile" aria-hidden="true"></span><span class="label">{{ $t('label.profile') }}</span>
                    </router-link>
                </li>
                <li v-has-role="['owner', 'manager']" :class="{ 'active': path === '/organization/settings/employees' }">
                    <router-link to="/organization/settings/employees">
                        <span class="icon icon-user" aria-hidden="true"></span><span class="label">{{ $t('label.employees') }}</span>
                    </router-link>
                </li>
                <li v-has-role="['owner', 'manager']" :class="{ 'active': path === '/organization/settings/services' }">
                    <router-link to="/organization/settings/services">
                        <span class="icon icon-list" aria-hidden="true"></span><span class="label">{{ $t('label.services') }}</span>
                    </router-link>
                </li>
                <li v-has-role="['owner', 'manager']" :class="{ 'active': path === '/organization/settings/materials' }">
                    <router-link to="/organization/settings/materials">
                        <span class="icon icon-materials" aria-hidden="true"></span><span class="label">{{ $t('label.materials') }}</span>
                    </router-link>
                </li>
                <li  :class="{ 'active': path === '/organization/settings/account' }">
                    <router-link to="/organization/settings/account">
                        <span class="icon icon-services" aria-hidden="true"></span><span class="label">{{ $t('label.account') }}</span>
                    </router-link>
                </li>
            </ul>
        </div>

        <transition name="fade">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
  export default {
    name: 'Name',
    data () {
      return {
        name: 'Name',
        path: this.$route.fullPath
      }
    },
    watch: {
      '$route.fullPath': function (path) {
        this.path = path
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/Settings/Settings.vue